export interface AssignedAdmin {
  id: number;
  name: string;
  admin_type: string;
}

export interface GetReq {
  id: number;
  status: Status;
  stage: Stage;
  type: Type;
  created_at: Date;
  updated_at: Date;
  is_deleted: boolean;
  feedback: null;
  user_id: number;
  post_id: number | null;
  user_name: string;
  user_university_id: string;
  user_gender: string;
  user_date_of_birth: string;
  user_email: string;
  post_title: null | string;
  reviewers: Reviewer[];
  has_unresolved_changes: boolean;
  assigned_admin_id: number | null;
  assigned_at: string | null;
  assigned_admin: AssignedAdmin | null;
}

export interface Reviewer {
  id: number;
  name: string;
  admin_type: string;
}

export enum Stage {
  AcademicSupervision = 'ACADEMIC_SUPERVISION',
  ProgramHead = 'PROGRAM_HEAD',
  Registration = 'REGISTRATION',
}

export enum Status {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Assigned = 'ASSIGNED',
  Rejected = 'REJECTED',
  ChangeRequested = 'CHANGE_REQUESTED',
}

export enum Type {
  PostSubmission = 'POST_SUBMISSION',
  Registration = 'REGISTRATION',
}
